import { Location } from 'history';
import { isEmpty, isUndefined } from 'lodash';
import { MenuItem } from '../contentful/contentfulClient';

const locationToPath = (location: Location) => location.pathname.split('/').map(s => s.trim()).filter(s => !isEmpty(s));

function findMenuItemAs<T>(
    path: Array<string>,
    items: Array<MenuItem>,
    def: () => MenuItem | undefined,
    as: (m: MenuItem | undefined) => T): T {
    const name = path.shift();
    const item = items.find(i => i.category === name);
    if (!isUndefined(item)) {
        if (isEmpty(item.subMenuItems) || isEmpty(path)) {
            return as(item);
        }
        return findMenuItemAs(path, item.subMenuItems || [], def, as);

    }
    return as(def());
}

function asCategories(item?: MenuItem): Array<string> {
    return item && item.category ? [item.category] : [];
}

function withDefault(items: Array<MenuItem>): MenuItem | undefined {
    const flatted = new Array<MenuItem>();
    items.forEach(item => {
        flatted.push(item);
        flatted.push(...(item.subMenuItems || []));
    });
    return flatted.find(i => i.isDefaultLocation);
}

export const extractCategories: (location: Location, items: Array<MenuItem>) => Array<string> =
    (location, items) => findMenuItemAs(locationToPath(location), items, () => withDefault(items), asCategories);

export const isValidLocation: (location: Location, items: Array<MenuItem>) => boolean =
    (location, items) => findMenuItemAs(locationToPath(location), items, () => undefined, x => !isUndefined(x));



// WEBPACK FOOTER //
// ./src/menu/CategoriesExtractor.ts